/*  eslint-disable no-unused-vars */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fa4 } from '@fortawesome/free-solid-svg-icons';

function CPState4({ s4Done }) {
  return (
    <div className="CPS1" style={{ backgroundColor: s4Done ? 'green' : null }}>
      <div className="CPS1_A1">
        <FontAwesomeIcon icon={fa4} />
      </div>
      <div className="CPS1_A2">
        Publish course
      </div>
    </div>
  );
}

export default CPState4;
/*  eslint-enable no-unused-vars */
